import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ProjectProviders } from './components/shared/ProjectProviders.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ProjectProviders>
      <App />
    </ProjectProviders>
  </StrictMode>,
)
